import React from 'react';
import MediaControls from './MediaControls.jsx';
import MediaIndicator from './MediaIndicator.jsx';
import AddressDisplay from './AddressDisplay.jsx';
import SessionControlPanel from './SessionControlPanel.jsx';
import DisplayBottomBar from './DisplayBottomBar.jsx';

/**
 * Affichage carte + audio.
 * 
 * Layout :
 *  1. Bouton toggle (audio+carte ↔ vidéo)
 *  2. Adresse
 *  3. Carte
 *  4. Timeline maître (GPS) + boutons
 *  5. Indicateur média (barre + volume) — juste en dessous
 */
const AudioMapDisplay = ({ refs, address, viewState, timelineState, slaveState, mediaHandlers, sessionData, isHistoricalMode, canGoLive, rotationMode, toggleRotationMode }) => (
  <div
    id="audio-map-display-section"
    ref={refs.audioMapDisplaySection}
    className="display-mode-section"
    style={{ display: viewState?.audioMapSection ? 'flex' : 'none' }}
  >
    <div
      id="map-container-audio"
      ref={refs.mapContainerAudio}
      className="map-container"
      style={{ position: 'relative' }}
    >
      <AddressDisplay addressRef={refs.addressDisplayAudio} text={address} />
      <SessionControlPanel sessionData={sessionData} isHistoricalMode={isHistoricalMode} />
    </div>

    {/* Maître : timeline GPS */}
    <MediaControls
      timelineState={timelineState}
      onPlay={mediaHandlers?.onPlay}
      onPause={mediaHandlers?.onPause}
      onStart={mediaHandlers?.onStart}
      onGoLive={mediaHandlers?.onGoLive}
      canGoLive={canGoLive}
      onTimelineInput={mediaHandlers?.onTimelineInput}
      onTimelineChange={mediaHandlers?.onTimelineChange}
      idPrefix="audio-"
    />

    {/* Indicateur média + volume — juste sous la timeline */}
    <MediaIndicator
      timelineState={timelineState}
      slaveState={slaveState}
      onVolumeChange={mediaHandlers?.onVolumeChange}
      mediaType="audio"
    />
    {viewState?.toggleAudioVisible && (
      <DisplayBottomBar
        currentView="audio-map"
        canSwitchView
        onSwitchView={() => refs.toggleViewButton.current?.click()}
        rotationMode={rotationMode}
        onToggleRotation={toggleRotationMode}
      />
    )}
  </div>
);

export default AudioMapDisplay;
